export const navItems = [
  { label: '求证台账', href: '#ledger' },
  { label: '辟谣与实锤', href: '#verdict' },
  { label: '聊天记录流出', href: '#records' },
  { label: '爆料人现身', href: '#sources' },
  { label: '求证FAQ', href: '#faq' },
];

export const quickCards = [
  {
    no: '01',
    category: '出行政策',
    claim: '网传五一高速免费时段延长至 5 天',
    verdict: '已辟谣',
    verdictKey: 'debunked',
    note: '截图疑为往年通知改期拼贴，免费时段仍以当年公告为准。',
  },
  {
    no: '02',
    category: '放假安排',
    claim: '网传调休方案再延两天、连休最长 7 天',
    verdict: '求证中',
    verdictKey: 'pending',
    note: '官方尚未公布新方案，流传版本暂无法在权威来源中找到。',
  },
  {
    no: '03',
    category: '购票渠道',
    claim: '12306 候补购票长期开放、更看重放票时段',
    verdict: '已实锤',
    verdictKey: 'confirmed',
    note: '候补购票功能真实存在，可在官方渠道直接使用，属网传属实。',
  },
  {
    no: '04',
    category: '景区提示',
    claim: '网传扫码领「景区免票券」可抢免费票',
    verdict: '已辟谣',
    verdictKey: 'debunked',
    note: '官方未开展相关活动，扫码多为引流，谨防套取个人信息。',
  },
];

export const featured = {
  kicker: '本期深度求证',
  title: '一张「连休 7 天」截图，如何从群聊传到全网',
  sub: '五一放假安排是每年最容易被加工的话题。我们从流传最早的一条群聊截图出发，按时间线还原它经历了哪几步变形，再逐一比对官方口径。',
  timeline: [
    { tag: '流传源头', text: '一段未经署名的群聊截图，称「内部方案：五一再延两天」。' },
    { tag: '二次加工', text: '截图被加上手写红字与新闻台标，转发量开始放大。' },
    { tag: '官方比对', text: '在国务院办公厅历年通知中未检索到对应表述，属虚构拼接。' },
    { tag: '栏目结论', text: '判定为网传消息 · 已辟谣；同类「改期」截图需警惕时间戳与台标异常。' },
  ],
};

export const ledgerStates = [
  { key: 'debunked', label: '已辟谣', note: '核实为不实或拼接内容', accent: 'secondary' },
  { key: 'confirmed', label: '已实锤', note: '多方比对确认为真', accent: 'primary' },
  { key: 'pending', label: '求证中', note: '信源不足，等待官方口径', accent: 'accent' },
];

export const debunkedItems = [
  { title: '网传「五一高速免费提前至假期前两天 0 时」', verdict: '不实', detail: '免费时段与车辆范围均以当年交通运输公告为准，流传图为往年通知改期。' },
  { title: '网传「调休再延两天，连休最长 7 天」', verdict: '不实', detail: '未在任何权威渠道检索到新方案，流传图片存在台标与时间戳拼接痕迹。' },
  { title: '网传「扫码可领景区免票券、穿汉服免费入园」', verdict: '不实', detail: '涉事景区与文旅部门均已澄清未开展活动，扫码多为钓鱼引流。' },
  { title: '网传「私信客服可低价代抢/包车，先付定金」', verdict: '不实', detail: '均为非官方渠道，涉诈骗风险，请勿向私人账户转账。' },
];

export const confirmedItems = [
  { title: '12306 候补购票功能持续开放，假期抢票更看重放票时段', verdict: '属实', detail: '候补购票可在官方渠道直接使用，与「内部名额」类说法无关。' },
  { title: '五一期间 7 座及以下小型客车免收通行费', verdict: '属实', detail: '免费通行口径来自交通运输部门，为历年假期常规安排。' },
  { title: '多地 A 级景区假期实行实名预约与限流入园', verdict: '属实', detail: '文旅部门已发布公告，需提前在官方平台预约，谨防转卖预约码。' },
  { title: '主要城市假期延长地铁公交夜间运营、加开夜间列车', verdict: '属实', detail: '多地交通部门已公布延长与加开安排，可按需查询末班时间。' },
];

export const pendingItems = [
  { title: '热门高铁线路假期增开夜间班次并下调票价', verdict: '求证中', detail: '有线路调整迹象，但尚无官方增开与调价公告，需继续跟进。' },
  { title: '部分景区五一后门票恢复原价并小幅上调', verdict: '求证中', detail: '以个别景区售票页价格变动为依据，尚未见统一口径。' },
  { title: '平台将按比例收取「假期服务费」', verdict: '求证中', detail: '未在收费规则中找到对应条目，等待官方客服口径确认。' },
  { title: '多地共享单车假期免费骑行 3 天', verdict: '求证中', detail: '仅见活动海报截图，暂无法核实是否为官方活动。' },
];

export const chatThread = {
  groupName: '拼车/出行互助群（8 人）',
  lines: [
    { role: 'self', name: '我', text: '群里传的这张「连休7天」图大家看到没？说是内部方案。', time: '14:02' },
    { role: 'other', name: '阿林', text: '我看了下，截图顶上有个新闻台标，但字体不太对。', time: '14:05' },
    { role: 'other', name: '兜兜妈', text: '我还刷到别人把它 P 成官方发的了，太像了…', time: '14:07' },
    { role: 'self', name: '我', text: '我先去官网核对下发布日期，晚点把结果贴群里。', time: '14:11' },
  ],
};

export const recordCards = [
  { no: 'A', tag: '车票群流出', title: '「加钱能插队候补」的聊天截图', body: '截图多为私人中介对话，未标注身份与资质，官方渠道不存在插队通道。' },
  { no: 'B', tag: '业主群转发', title: '「小区门口发景区免费券」提醒', body: '仅见横幅式图片，未见盖章原件，已按「截图无原始出处」原则标记存疑。' },
];

export const informants = [
  { role: '景区票务从业者', uid: '留档 B01', quote: '我这边没有收到「穿汉服免票」的活动文件，扫码领券十有八九是引流用的。', strength: '一手工作接触，口径一致', verified: true },
  { role: '铁路系统匿名人员', uid: '留档 B02', quote: '候补购票靠的是放票时段和真实余票，不存在内部加价插队这一说。', strength: '与官方公开口径一致', verified: true },
  { role: '平台客服（化名）', uid: '留档 B03', quote: '「假期服务费」我在收费规则里没有找到，建议以页面公示为准。', strength: '口径偏谨慎，建议二次核验', verified: false },
];

export const methodSteps = [
  { no: '一', title: '找原始出处', text: '不依赖二次转发，回溯截图与消息最早出现的账号与时间。' },
  { no: '二', title: '交叉信源', text: '同一事实至少经两个互不依赖的来源佐证，避免以讹传讹。' },
  { no: '三', title: '权威口径', text: '优先对齐官方公告、服务条款与公开数据，作为最终定论依据。' },
  { no: '四', title: '留档与更新', text: '给每条网传消息编号留档，结论变化时在台账中同步更正。' },
];

export const faqs = [
  {
    q: '「实锤」和「辟谣」在栏目里分别代表什么？',
    a: '实锤指经多方比对与官方口径确认为真的网传消息；辟谣指核实为不实、拼接或过时改期的内容。两者都会标注依据，便于你回查。',
  },
  {
    q: '栏目如何处理来源不明的聊天记录截图流出？',
    a: '缺少原始署名、时间戳异常或无盖章原件的截图，一律先标记为存疑，再尝试从官方渠道或一手接触人处交叉验证，不会直接采信。',
  },
  {
    q: '想提供线索，爆料人可以怎么联系我们？',
    a: '欢迎通过页面底部的联系方式留言（示意，不产生真实提交）。请尽量附上原始截图与来源账号，匿名或实名均可，我们会在台账中为你留档编号。',
  },
  {
    q: '辟谣与实锤的结论会更新吗？',
    a: '会。求证台账按日期归档，一旦官方口径或新证据出现，我们会在对应条目的详情里同步更正，并保留原始结论的留档记录。',
  },
];